const constitutionModalSteps = {
  SCRIPTURE: 'scripture',
  MOVEMENTS: 'movements',
  PREVIEW: 'preview',
} as const;

export type ConstitutionModalStep =
  (typeof constitutionModalSteps)[keyof typeof constitutionModalSteps];

export default constitutionModalSteps;
